<template>
  <div id="resource-canvas" class="offcanvas-background">
    <div class="offcanvas offcanvas-right"
       v-click-outside="close">
    <div class="offcanvas-header d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center">
        <inline-svg :src="require('@/assets/images/icons/Icon_Folder.svg')"
                    class="mr-3"
                    width="40" height="40"/>
        <span class="font-weight-light" style="font-size: 2.5rem">
          {{$t('app.label.resource')}}
        </span>
      </div>
      <span class="btn btn-xs btn-icon btn-hover-primary ml-auto"
         @click="close">
        <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                    width="20" height="20"/>
      </span>
    </div>
    <div class="offcanvas-content h-100 pb-8">
      <div class="resources-list h-100" v-show="showList" v-if="resources" >
        <ResourceFolder :data="resources" :root="true" @showResource="showResource"/>
      </div>
      <div v-show="!showList" class="h-100">
        <div class="d-flex align-items-center cursor-hand mb-4" @click="closeResource">
          <inline-svg :src="require('@/assets/images/icons/Icon_DropdownArrow_Down.svg')"
                      class="mr-3"
                      style="transform: rotate(90deg)"
                      width="17" height="17"/>
          <span class="h4 mb-0" ref="resourceName"></span>
        </div>
        <div v-if="!resourceLoaded"
             class="d-flex align-items-center justify-content-center h-100 w-100">
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div
          id="resourceFrame" ref="resourceFrame">
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ResourceFolder from '@/components/ui/ResourceFolder.vue';
import store from '@/store';
import { FILE_CONTENT } from '@/store/actions.type';

export default {
  name: 'SessionResourcesModal',
  components: { ResourceFolder },
  computed: {
    ...mapGetters(['resources', 'currentSession']),
  },
  data() {
    return {
      loading: false,
      resourcesModal: true,
      showList: true,
      resourceLoaded: false,
    };
  },
  methods: {
    close() {
      if (document.getElementById('resource-canvas').classList.contains('offcanvas-on')) {
        this.$emit('close', { src: 'resource' });
      }
    },
    showResource(resource) {
      const payload = {
        session: this.currentSession.id,
        resourceId: resource.id,
        fileType: resource.type,
        fileName: resource.filename,
      };
      this.showList = false;
      this.resourceLoaded = false;
      this.$refs.resourceName.innerHTML = resource.path;
      store.dispatch(FILE_CONTENT, payload).then((url) => {
        const container = this.$refs.resourceFrame;
        let object = null;
        if (resource.type === 'PDF') {
          object = document.createElement('object');
          object.data = url;
        } else if (resource.type === 'IMAGE') {
          object = document.createElement('img');
          object.src = url;
        } else if (resource.type === 'VIDEO') {
          object = document.createElement('video');
          object.setAttribute('autoplay', '');
          object.setAttribute('type', 'video/mp4');
          object.setAttribute('controls', 'true');
          object.src = url;
        }
        if (object) {
          container.appendChild(object);
          this.resourceLoaded = true;
        }
      });
    },
    closeResource() {
      this.$refs.resourceFrame.innerHTML = '';
      this.$refs.resourceName.innerHTML = '';
      this.showList = true;
      this.resourceLoaded = false;
    },
  },
};
</script>
<style>
#resourceFrame{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#resourceFrame object,
#resourceFrame img,
#resourceFrame video{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style>
